import { FormControl, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LoadingSpinner from 'components/LoadingSpinner';
import VodPlayer from 'components/VodPlayer';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { conferenceTokenAuthAction } from 'store/user/userActions';
import { openedVod } from 'utils/apiCalls';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    '& > *': {
      marginTop: '1rem',
    },
  },
  vodWrapper: {
    background: theme.palette.background.dark,
    border: '1px solid',
    borderColor: theme.palette.background.light,
    width: '75vw',
    height: '53.44vw',
    maxWidth: '75vw',
    maxHeight: '80vh',
    overflow: 'hidden',
  },
  vodSelect: {
    minWidth: '20rem',
  },
}));

export default function Vod() {
  const dispatch = useDispatch();
  const [videoUrl, setVideoUrl] = useState('');
  const [minTime, setMinTime] = useState(0);
  const [maxTime, setMaxTime] = useState(0);
  const classes = useStyles();
  const { title, Vod, conferenceTokenAuthLoading, conferenceTokenAuthError } = useSelector(
    ({ conference, user }) => ({
      SessionId: conference.SessionId,
      title: conference.Title,
      descriptionText: conference.Description,
      Vod: conference.Vod,
      conferenceTokenAuthLoading: user.actionStatus?.conferenceTokenAuth?.loading,
      conferenceTokenAuthError: user.actionStatus?.conferenceTokenAuth?.error,
    })
  );

  const queryRef = new URLSearchParams(useLocation().search);
  const query = useRef(queryRef);

  useEffect(() => {
    const token = query.current.get('token');
    localStorage.setItem('conference-token', btoa(token));
    // removeTokenFromQuery();
    dispatch(conferenceTokenAuthAction({ token }));
    // eslint-disable-next-line
  }, []);

  if (conferenceTokenAuthLoading || !Vod) return <LoadingSpinner />;
  if (conferenceTokenAuthError) return null;

  const vods = Vod; //.sort((a, b) => a.Start - b.Start);

  const onChangeVod = (event) => {
    const { Url, StartTime, EndTime } = vods.find((vod) => vod.Url === event.target.value);
    setVideoUrl(Url);
    setMinTime(StartTime);
    setMaxTime(EndTime);
    openedVod(Url);
  };

  return (
    <div className={classes.root}>
      <Typography variant="h5">{title}</Typography>

      <div className={classes.vodWrapper}>
        {videoUrl && <VodPlayer vodUrl={videoUrl} minTime={minTime} maxTime={maxTime} />}
      </div>

      <FormControl>
        <InputLabel id="vod-select-label">Recording</InputLabel>
        <Select
          id="vod-select"
          labelId="vod-select-label"
          value={videoUrl}
          onChange={onChangeVod}
          className={classes.vodSelect}
        >
          {vods
            .filter((video) => video.Published)
            .map((video) => (
              <MenuItem value={video.Url} key={video.Url}>
                {video.Name || moment(video.Start).format('LLL')}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      <Typography variant="caption">Select a video clip above to playback.</Typography>
    </div>
  );
}
